import { Component, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation, IOperationListColumnResponse, OperationsListRequest, IEditRowField } from '../../airport-interfaces';
import { AirportService } from '../../airport.service';
import { ScenarioService } from '../../../scenario-activities/scenario.service';
import { UserInfoService } from '../../../shared/user-info.service';
import { UserSession } from '../../../shared/user-session';
import { Button } from 'primeng/primeng';
import { Checkbox } from 'primeng/primeng';
import * as _ from 'lodash';

import {SystemControl} from '../../../shared/system-control';
import {SystemControlElem} from '../../../shared/system-control-elem';
import { SystemControlService} from '../../../shared/system-control.service';

@Component({
    selector: 'operations-graph-selections',
    template: require('./operations-graph-selections.component.html'),
    styles: [require('../../../styles/faa_styles.css')],
    directives: [Button, Checkbox]
})

export class OperationsGraphSelectionsComponent implements OnInit, OnDestroy{
    @Input() operation: IOperation;
    @Input() selected: boolean;
    @Input() locId: string;
    @Input() airportName: string;
    @Input() displayAll: boolean;

    
    columns: IOperationListColumnResponse[];
    
    errorMessage: string;
    systemControlElem: SystemControlElem;
    
    startYears:number[] = [];
    endYears:number[] = [];

    selectedStartYear: number;
    selectedEndYear: number;
    graphType: string = "bar";
    yearsToPreview: number = 4;
    hasData: boolean;
    dataCheckDone: boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService,
                private _userInfoService: UserInfoService, 
                private User: UserSession,
                private request: OperationsListRequest,
                private _systemControlService:SystemControlService) 
    {}

    ngOnInit(): void{
        if(this.selected){
            
                let params = {
                    tableName: this.operation.tableName,
                    locId: this.locId,
                    scenarioId: this.User.getSession().scenarioId
                }

                this._airportService.hasGraphData(params)
                    .subscribe(
                        response => {
                            if(response.hasData){

                                this.hasData = true;
                                this.dataCheckDone = true;

                                this.getColumns();

                                this.getSystemControlValues();
                            }
                            else{
                                this.hasData = false;
                                this.dataCheckDone = true;
                            }
                        },
                        error => {
                            this.errorMessage = "Server Error";
                            console.error(error);
                        }
                    );
        }
    }
    
    getColumns(){
        this.request.tableName = this.operation.tableName;
        this.request.scenarioId = this.User.getSession().scenarioId;
        this.request.locId = this.locId;
        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
        this._airportService.getOperationsColumns(this.request)
                .subscribe(
                    columns => this.columns = columns,
                    error => this.errorMessage = <any>error);
    }

    getSystemControlValues(){
        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => {
                    this.systemControlElem = systemControlElem;
                    this.populateYears();
                },
                error => this.errorMessage = <any>error);
    }

    populateYears(){

        this._userInfoService.getRegionalYear(this.User.getSession()['id'])
            .subscribe(
                success => {
                    this.populateStartYears(success.startYear);
                    this.populateEndYears(success.endYear);

                }
            );
    }

    populateStartYears(startYear: any){

        let params = {
            tableName: this.operation.tableName,
            locId: this.locId,
            scenarioId: this.User.getSession().scenarioId

        };

        let minYear: number;

        this._airportService.getGraphMinYear(params)
            .subscribe(
                min => {
                    minYear = min;

                    let index = 0;
                    for(let year = minYear; year <= this.systemControlElem.lfcYear; year++){
                        this.startYears[index] = year;
                        index++;
                    }

                    //need to set selected one
                    if(startYear){
                        this.selectedStartYear = startYear;
                    }
                    else{
                        this.selectedStartYear = this.systemControlElem.ffcYear - this.yearsToPreview;
                    }
                }
            );
    }

    populateEndYears(endYear: any){

        let index = 0;
        for(let year = this.systemControlElem.ffcYear - this.yearsToPreview; year <= this.systemControlElem.lfcYear; year++){
            this.endYears[index] = year;
            index++;
        }
        //console.log("this.systemControlElem.ffcYear" + this.systemControlElem.ffcYear +" " + this.systemControlElem.lfcYear)
        //need to set selected one
        if(endYear){
            this.selectedEndYear = endYear;
           // console.log("populateEndYears" +endYear );
        }
        else{
            this.selectedEndYear = this.systemControlElem.ffcYear - this.yearsToPreview;
            
        }
    }

    ngOnDestroy(){}

    generateGraph(){
       
       this.errorMessage = null;

        let selectedColumns = this.columns.filter(function(column){
            return column.graphR == 1;
        });

        if(selectedColumns.length === 0){
            this.errorMessage = "At least one data column must be selected."
            return;
        }

        if(this.selectedEndYear <= this.selectedStartYear){
            this.errorMessage = "Selected end year must be greater than the selected start year."
            return;
        }
        
        sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));

        let params = {
            displayName: this.operation.displayName,
            locId: this.locId,
            airportName: this.airportName,
            graphType: this.graphType,
            startYear: this.selectedStartYear,
            endYear: this.selectedEndYear,
            quickGraph: "false"
        };

        this.router.navigate([`/operations-graph-display/${this.operation.tableName}`, params]);
    }
}




/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operations-graphs/operations-graph-selections.component.ts
 **/